///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { patterns } from "./types";

const formatMessage = userMessage => {
  if (userMessage && userMessage.message) {
    let message = userMessage.message;
    while (message.match(patterns.userMentions)) {
      const match = message.match(patterns.userMentions);
      const userName = match[2].slice(2, match[2].lastIndexOf("(") - 1);
      message = message.replace(
        match[2],
        "<span class='weight--semibold'>@" + userName + "</span>"
      );
    }
    userMessage.message = message;
    return userMessage;
  }
};

export default formatMessage;
